import { Role } from '../../../shared/enum';
import { Folder } from '../../resources/folders/models';

type UserFoldersBodyProps = { role: Role; folders?: Folder[] };

export const UserFolders = ({ role, folders }: UserFoldersBodyProps) => {
  if (role === Role.FullAdmin) {
    return <>All</>;
  }

  if (folders && folders.length > 0) {
    return <>{folders.map(({ name }) => name).join(', ')}</>;
  }

  return <>None</>;
};
